/* ========= DIAMOND API URL ========= */
var diamondApiUrl = "https://diamondapi.ringconcierge.com";
/* ========= DIAMOND FEED API URL ========= */
var diamondFeedApiUrl = "https://vapi.ringconcierge.com";
/* ========= API URL PATH ========= */
var apiUrlPath = "https://ring-concierge.myshopify.com";
/* ========= API VERSION ========= */
var apiVersion = "/admin/api/2026-04/";
/* ========= STORE URL ========= */
var storeUrlJs = "ring-concierge.myshopify.com";

/* ========= VENDOR MAP ========= */
const VENDOR_MAP = {
  "68119": "RR",
  "56068": "JR",
  "21684": "RDI",
  "25333": "HZ",
  "103644": "RC",
  "66863": "OM",
  "111935": "DR",
  "117373": "NK",
  "61666": "BL",
  "80926": "BC",
  "19029": "DG",
  "100": "SL",
  "101": "GR",
  "102": "FN",
  "106054": "MD",
  "100332": "Aarush",
  "1643772": "EM",
  "1643001": "EL"
};

/* ========= SHAPE MAP ========= */
const SHAPE_MAP = {
  "round": "RD",
  "oval": "OV",
  "pear": "PS",
  "radiant": "RA",
  "cushion": "CU",
  "emerald": "EC",
  "princess": "PR",
  "european": "OE",
  "old cut round": "OE",
  "antique style round": "OE",
  "old mine": "OM",
  "old cut cushion": "OM",
  "antique style cushion": "OM"
};

/* ========= DIAMOND SHAPE IMAGES MAP ========= */
const SHAPE_IMAGE_MAP = {
  round: 'https://cdn.shopify.com/s/files/1/1359/2701/files/round.png',
  oval: 'https://cdn.shopify.com/s/files/1/1359/2701/files/oval.png',
  pear: 'https://cdn.shopify.com/s/files/1/1359/2701/files/pear.png',
  radiant: 'https://cdn.shopify.com/s/files/1/1359/2701/files/radiant.png',
  cushion: 'https://cdn.shopify.com/s/files/1/1359/2701/files/cushion.png',
  emerald: 'https://cdn.shopify.com/s/files/1/1359/2701/files/emrald.png',
  antiquestyleround: 'https://cdn.shopify.com/s/files/1/1359/2701/files/antiquestyleround.png',
  antiquestylecushion: 'https://cdn.shopify.com/s/files/1/1359/2701/files/antiquestylecushion.png',
  marquise: 'https://cdn.shopify.com/s/files/1/1359/2701/files/marquise_pink.jpg?v=1702374856'
};

/* ========= GRAB VENDOR ID THROUGH NAME ========= */
const VENDOR_NAME_TO_ID = {
  "USNY": 2,
  "RDI": 3,
  "RC": 4,
  "HZ": 5,
  "JR": 6,
  "OM": 7,
  "RR": 8,
  "NK": 9,
  "DR": 10,
  "Super Bell Jewelry": 11,
  "Midas Chain": 12,
  "Sindbad": 13,
  "Laura Jewelry": 14,
  "Stuller": 15,
  "Quality Gold": 16,
  "Arzy": 17,
  "Jeweler's Choice": 18,
  "Aaron Jewelry": 19,
  "Rio Grande": 20,
  "Urbaetis Fine Jewelry": 21,
  "Urbaetis Fine Jewelry -2": 22,
  "Beny Sofer": 23,
  "KAIN New York": 24,
  "Royal Chain": 25,
  "BL": 26,
  "Unique - PO": 27,
  "Unique - Email": 28,
  "Kelly Bello": 29,
  "Noble": 30,
  "Pinnacle": 31,
  "BC": 32,
  "Laser Booth": 37,
  "GF": 38,
  "QA Vendor": 39,
  "DG": 44,
  "Ramesh Cooke LLC": 45,
  "Shanli": 47,
  "FN": 48,
  "GR": 49,
  "SL": 50,
  "S&J Diamond Corp.": 51,
  "Christelle Ltd.": 53,
  "MD": 54,
  "HMS Jewelry Contracting LTD.": 55,
  "Advan Jewelry Limited": 56,
  "Saban Onyx": 57,
  "Kozza": 59,
  "JC": 60,
  "VDA": 62,
  "Emby": 63,
  "Pranda": 64,
  "Sunjewels Private Limited": 65,
  "KARIZIA SPA": 66,
  "UNOAEERE INDUSTRIES SPA": 67,
  "EVERLEE by Ofer Mizrahi Diamonds": 68,
  "Lavish": 69,
  "Rick's Creations": 72,
  "Wolf 1834": 73,
  "Uni-Design Jewellry PVT. LTD.": 74,
  "In Record Time": 75,
  "Town Talk Polish Co, LTD.": 76,
  "Profusion Inc.": 77,
  "Greg B. Jewelers": 78,
  "Sasha Primak": 79,
  "Haviters": 80,
  "RGV Group LLC.": 81,
  "Aarush": 82,
  "Test Vendor": 83,
  "Progress Luv2Pak International": 84,
  "INDOJEWEL JEWELLERY PRIVATE LIMITED": 85,
  "EM": 86,
  "Mondrian Collection LLC": 87,
  "EL": 88,
  "Kira Jewels Inc": 89,
  "MJJ Brilliant": 90,
  "Mercy Jewelry Co., Ltd": 91,
  "Mioro Gold LLC": 92,
  "Unidesign Fareast Limited": 93,
  "Fenix Diamond (HK) Limited": 94
};

/* ========= CERTIFICATE URL BUILDER ========= */
function getCertificateUrl(diamond, isLabGrown) {
  let certificateUrl = `https://www.gia.edu/report-check?reportno=${diamond.cert_num}`;
  let source = diamond.source;
  // NON RAPNET SOURCES
  if (diamond.hasOwnProperty("source") && diamond.source !== 'Rapnet') {
    source = diamond.source;
    certificateUrl = `https://www.gia.edu/report-check?reportno=${diamond.cert_num}`;
  }
  // IMAGE-BASED CERTIFICATES
  if (source === "FN" || source === "GR" || source === "SL" || source === "MD") {
    certificateUrl = diamond.certificate_image;
  }
  // LAB GROWN IGI (AARUSH)
  if (isLabGrown) {
    if (diamond.source === 'AA') {
      const encodedRtn = btoa(diamond.cert_num);
      certificateUrl = `/pages/igi-certificate?rtn=${encodedRtn}`;
    }
  }
  return certificateUrl;
}

/* ========= DIAMOND VIDEO: CONSTANTS ========= */
const NO_VIDEO_HTML = `
  <div class="no-video-msg">
    Video of the diamond
  </div>
`;

/* ========= DIAMOND VIDEO: API ========= */
function getVideoUrlFromRdi(stockId, cb) {
  const body = {
    apiUrl: `https://api.rdidiamonds.com/v1/check-media/${stockId}?key=hfjfHVhPuy9VhUNQ4SFrz5w9`,
    method: 'GET'
  };
  commonApiCalls(body, (data) => cb(null, data));
}

/* ========= DIAMOND VIDEO: HELPER(1) ========= */
function normalizeVideoUrl(url) {
  if (!url) return '';
  if (url.includes('360diamondview')) {
    return url.replace("&zoomslide=0", '');
  }
  if (url.includes('//v360.in/') && !url.includes('&sv=1')) {
    return `${url}&sm=0&sv=1&zoomslide=0`;
  }
  if (url.indexOf('sv=1') === -1 || url.indexOf('sv=2') === -1){
    url = url.replace("sv=1","sv=0")
    url = url.replace("sv=2","sv=0")
  }
  return url;
}

/* ========= DIAMOND VIDEO: HELPER(2) ========= */
function renderIframe(panel, url, uniqueId) {
  panel.html(`
    <div class="VideoWrapper360">
      <div class="framesloader${uniqueId} loader__section">
        <div class="loader loader-20"><div class="css-diamond"></div></div>
      </div>
      <iframe 
        id="frames${uniqueId}"
        src="${url}"
        loading="lazy"
        tabindex="-1"
        allow="accelerometer; autoplay;"
        allowtransparency="true"
        onload="hideFrameLoader(${uniqueId})"
      ></iframe>
      <span class="caption">*actual diamond</span>
    </div>
  `);
}

/* ========= DIAMOND VIDEO: HELPER(3) ========= */
function renderSpriteSpin(panel, stockNumber, data) {
  let versions = data.versions[1] || data.versions[0];
  if (!versions || !versions.num_images) {
    panel.html(NO_VIDEO_HTML);
    return;
  }
  const imagePattern = versions.md_first_image.replace("000", "{frame}");
  panel.spritespin({
    source: SpriteSpin.sourceArray(imagePattern, {
      frame: [0, versions.num_images - 1],
      digits: 3
    }),
    width: 325,
    animate: true,
    detectSubsampling: true,
    loop: true,
    sense: -1,
    responsive: true,
    frameTime: 82,
    retainAnimate: true,
    plugins: ['360', 'drag'],
    onInit: function () {
      panel.append(`
        <div class="loadersprite11${stockNumber} loader__section">
          <div class="loader loader-20"><div class="css-diamond"></div></div>
        </div>
      `);
    },
    onComplete: function () {
      $(`.loadersprite11${stockNumber}`).fadeOut('slow', function () {
        $(this).remove();
      });
    }
  });
}

/* ========= HIDE FRAME LOADER ========= */
function hideFrameLoader(elm) {
  setTimeout(function () {
    $(`.framesloader${elm}`).fadeOut('slow', function () {
      $(`.framesloader${elm}`).remove();
    });
  }, 100);
}

/* ========= MAIN FUNCTION: LOAD DIAMOND VIDEO ========= */
function getDiamondVideo(el) {
  const cert = el.getAttribute("data-cert_num");
  if (!cert) {
    console.warn('cert_num missing');
    return;
  }
  const stockNumber = el.getAttribute("data-stockNumber");
  const uniqueId = el.getAttribute("uniqueid");
  let videoUrl = normalizeVideoUrl(el.getAttribute("videourl"));
  const panel = $(`#panel__inner${cert}`);
  /* ========= CASE 1: DIRECT VIDEO ========= */
  if (videoUrl && stockNumber) {
    const existingSrc = panel.find(`#frames${uniqueId}`).attr('src');
    if (existingSrc !== videoUrl) {
      renderIframe(panel, videoUrl, uniqueId);
    }
    return;
  }
  /* ========= CASE 2: RDI SPRITESPIN ========= */
  if (stockNumber) {
    getVideoUrlFromRdi(stockNumber, (err, data) => {
      if (err || !data || !data.exists) {
        panel.html(NO_VIDEO_HTML);
        return;
      }
      renderSpriteSpin(panel, stockNumber, data);
    });
    return;
  }
  /* ========= FALLBACK ========= */
  panel.html(NO_VIDEO_HTML);
}

/* ========= GRAB VENDOR NAME THROUGH ID ========= */
function getVendorName(id) {
  if (!id) return null;
  return VENDOR_MAP[id] || id;
}

/* ========= NORMALIZING SHAPE: TRIMMING ========= */
function normalizeShape(name) {
  return (name || '').toLowerCase().replace(/[-\s]+/g, ' ');  // normalize hyphen/space.trim();
}

/* ========= GRAB SHAPE ID THROUGH NAME ========= */
function grabShapeId(name) {
  if (!name) return null;
  const normalized = normalizeShape(name);
  return SHAPE_MAP[normalized] || name;
}

/* ========= GRAB VENDOR ID THROUGH NAME ========= */
function getVendorIdByName(vendorName) {
  if (!vendorName) return null;
  return VENDOR_NAME_TO_ID[vendorName] || VENDOR_NAME_TO_ID[vendorName.trim()] || null;
}

/* ========= GRAB URL PARAMETER VALUE ========= */
function getParameterByName(key) {
  return new URLSearchParams(window.location.search).get(key);
}

/* ========= SAVE SELECTED DIAMOND TO LOCAL STORAGE ========= */
function selectDiamond(diamond) {
  if (!diamond || !diamond.cert_num) {
    console.warn('Invalid diamond data');
    return false;
  }
  try {
    localStorage.setItem('rc_selected_diamond',JSON.stringify(diamond));
    return true;
  } catch (e) {
    console.error('Storage error:', e);
    return false;
  }
}

/* ========= GET SELECTED DIAMOND FROM STORAGE ========= */
function getSelectedDiamondFromStorage() {
  try {
    const data = localStorage.getItem('rc_selected_diamond');
    return data ? JSON.parse(data) : null;
  } catch (e) {
    return null;
  }
}

/* ========= CHECK IF DIAMOND EXISTS IN SHOPIFY, ELSE CREATE NEW DIAMOND PRODUCT ========= */
async function saveSelectedDiamond(diamond) {
  if (!diamond || !diamond.cert_num) return;
  const cert = diamond.cert_num;
  const ringSize = new URLSearchParams(window.location.search).get('Ring_Size');

  try {
    showLoader();
    selectDiamond(diamond);

    const cart = await fetch('/cart.js').then(r => r.json());
    const hasDiamond = cart.items.some(item =>
      item.product_type === "Diamond" ||
      item.product_type === "Vow Engagement Rings"
    );
    if (hasDiamond) {
      localStorage.setItem('_vow_item_cart', JSON.stringify(cart.items));
      localStorage.setItem('_clicked_button_cert_id', cert);
      $('#rc-generic-popup').find('.rc-popup-heading').text('You already have a custom engagement ring in your cart.');
      $('#rc-generic-popup').find('.rc-popup-subtext').text('This will remove the current ring in your cart and you can proceed with changing your ring.');
      $('#rc-generic-popup').find('.rc-popup-cta').text('UPDATE MY RING');
      $('#rc-generic-popup').addClass('open');
      return;
    }

    const shopifyProduct = await fetchShopifyProduct(cert);
    if (shopifyProduct?.variants?.length) {
      localStorage.setItem('selected-diamond-shopify-data', JSON.stringify(shopifyProduct));
      redirectToProductDetailPage(ringSize);  // pass it in
      return;
    }

    const createdProduct = await createDiamondProductShopify(diamond);
    if (createdProduct) {
      localStorage.setItem('selected-diamond-shopify-data', JSON.stringify(createdProduct));
      redirectToProductDetailPage(ringSize);  // pass it in
    }
  } catch (err) {
    console.error(err);
  } finally {
    hideLoader();
  }
}

/* ========= REDIRECT TO PDP AFTER DIAMOND SELECTED ========= */
function redirectToProductDetailPage(ringSize) {
  const urlParams = new URLSearchParams(window.location.search);
  const handle  = urlParams.get('handle');
  const variant = urlParams.get('variant');
  // Fallback: read from URL if not passed (e.g. called from elsewhere)
  const size = ringSize || urlParams.get('Ring_Size');
  const isStartWithSetting = urlParams.get('start-with-setting');
  // Forward shape only for these emerald orientation variants
  const EMERALD_VARIANTS = ['Emerald (North/South)', 'Emerald (East/West)'];
  const selectedVariants = (urlParams.get('shapes') || '')
    .split(',')
    .map(s => s.trim())
    .filter(s => EMERALD_VARIANTS.includes(s));

  if (handle && variant) {
    let url = `/products/${handle}?variant=${variant}&is_pre_cart=true`;
    if (size) url += `&Ring_Size=${encodeURIComponent(size)}`;
    if (isStartWithSetting) url += `&start-with-setting=true`;
    if (selectedVariants.length) {
      url += `&shapes=${encodeURIComponent(selectedVariants.join(','))}`;
    }
    window.location.href = url;
  } else {
    window.location.href = `/collections/ring-builder`;
  }
}

/* ========= CHECK PRODUCTS EXISTS OR NOT ========= */
async function fetchShopifyProduct(cert) {
  try {
    const res = await fetch(`${diamondApiUrl}/getshopifyapi`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        apiUrl: `${apiUrlPath}${apiVersion}products.json?handle=${cert}`,
        method: 'GET'
      })
    });
    const json = await res.json();
    return json?.products?.[0] || null;
  } catch {
    return null;
  }
}

/* ========= CREATE NEW DIAMOND PRODUCT IN SHOPIFY ========= */
async function createDiamondProductShopify(diamond) {
  try {
    const cert = diamond.cert_num;
    const res = await fetch(`${diamondApiUrl}/diamonds/getSingle`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cert_num: cert })
    });

    const json = await res.json();
    const d = json?.response?.body?.diamond;
    if (!d) return null;

    /* ========= BUILD EXACT PAYLOAD ========= */
    const product = buildDiamondProductPayload(d);

    /* ========= STORE PAYLOAD ========= */
    // localStorage.setItem('selected-diamond-data', JSON.stringify(product));

    /* ========= CREATE ========= */
    const createRes = await fetch(`${diamondFeedApiUrl}/product?shop=${storeUrlJs}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product })
    });

    const createData = await createRes.json();

    /* ========= Return Shopify's response (has variants[].id), fall back to re-fetching ========= */
    const shopifyProduct = createData?.product || createData;
    if (shopifyProduct?.variants?.[0]?.id) {
      return shopifyProduct;
    }
    /* ========= Fallback: re-fetch by handle to get the created product with ID ========= */
    const fetched = await fetchShopifyProduct(cert);
    return fetched || null;

  } catch (e) {
    console.error('ERROR IN CREATING DIAMOND:', e);
    return false;
  }
}

function buildDiamondProductPayload(diamond) {
  const cert = diamond.cert_num;
  const sellerName = diamond.rapnet_account_id
    ? `${getVendorName(diamond.rapnet_account_id)}`
    : '';
  const diamondShapeId = grabShapeId(diamond.shape);

  let sku = `BE-${sellerName}-${diamond.stock_num}-${diamondShapeId}-${cert}`;
  if (getParameterByName('diamondLabType') === "lab") {
    sku += "-LG";
  }

  let originalPrice = diamond.total_sales_price_in_currency || 'N/A';
  if (diamond.source === "Rapnet") {
    originalPrice = diamond.total_purchase_price || 'N/A';
  }

  const product = {
    title: `${diamond.shape} #${cert}`,
    vendor: getVendorName(diamond.rapnet_account_id),
    product_type: 'Diamond',
    handle: cert,
    taxable: true,
    variants: [{
      inventory_management: "shopify",
      inventory_quantity: 1,
      position: 1,
      price: diamond.marked_up_price?.toFixed(2) || '0',
      taxable: true,
      requires_shipping: true,
      sku
    }],
    tags: [
      `size: ${diamond.size || 'N/A'}`,
      `shape: ${diamond.shape || 'N/A'}`,
      `measurements: ${diamond.meas_length} x ${diamond.meas_width} x ${diamond.meas_depth}`,
      `price: ${originalPrice}`,
      `diamondId: ${diamond.diamond_id || 'N/A'}`,
      `color: ${diamond.color || 'N/A'}`,
      `clarity: ${diamond.clarity || 'N/A'}`,
      `symmetry: ${diamond.symmetry || 'N/A'}`,
      `polish: ${diamond.polish || 'N/A'}`,
      `cut: ${diamond.shape === "Round" ? diamond.cut : 'Excellent'}`,
      `cert_num: ${cert}`,
      `stock_num: ${diamond.stock_num || 'N/A'}`,
      `image_file_url: ${diamond.image_file_url || ''}`,
      `YBlocklist`,
      `diamond-product`,
      `ll-exclusion`,
      `${getVendorIdByName(sellerName) ? getVendorIdByName(sellerName) : ''}`
    ]
  };

  /* ========= LG HANDLING (EXACT LOGIC) ========= */
  const labVendors = ['SL', 'GR', 'FN', 'MD', 'Aarush', 'RC', 'EL'];
  if (diamond.lg === true || labVendors.includes(diamond.source)) {
    product.tags.push("LG");
  }

  /* ========= ADD PRODUCT IMAGE ========= */
  const imageUrl = getDiamondImageUrl(product, diamond.shape);
  product.images = [{ src: imageUrl }];

  return product;
}

/* ========= GRAB SELECTED DIAMOND IMAGE URL ========= */
function getDiamondImageUrl(product, shape) {
  const defaultImageUrl = 'https://rc-diamond-images.s3.us-east-2.amazonaws.com/defaultDiamondImages/noImage.png';
  const normalized = normalizeShape(shape);
  const shapeImage = SHAPE_IMAGE_MAP[normalized];
  const imageTag = product?.tags?.find(tag => tag.startsWith("image_file_url:"));
  const tagImage = imageTag ? imageTag.replace("image_file_url: ", "") : null;
  return shapeImage || tagImage || defaultImageUrl;
}

/* ========= ALREADY DIAMOND POPUP: UPDATE MY RING ========= */
document.getElementById('rc-generic-popup-cta-action')?.addEventListener('click', async function () {
  const btn = this;
  btn.textContent = 'Removing...';
  btn.disabled = true;

  try {
    /* === Get stored cart items and cert === */
    const cartItems = JSON.parse(localStorage.getItem('_vow_item_cart') || '[]');
    /* === Find all ring/diamond line item keys to remove === */
    const keysToRemove = {};

    cartItems.forEach(item => {
      if (
        item.product_type === 'Diamond' ||
        item.product_type === 'Vow Engagement Rings'
      ) {
        keysToRemove[item.key] = 0;
      }
    });

    /* === Also remove any items associated via _associated_unique_key === */
    const associatedKeys = new Set(
      cartItems
        .filter(i => i.product_type === 'Diamond' || i.product_type === 'Vow Engagement Rings')
        .map(i => i.properties?.['_associated_unique_key'])
        .filter(Boolean)
    );

    cartItems.forEach(item => {
      const uid = item.properties?.['_associated_unique_key'];
      if (uid && associatedKeys.has(uid)) {
        keysToRemove[item.key] = 0;
      }
    });

    if (Object.keys(keysToRemove).length > 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: keysToRemove })
      });
    }

    /* === Clean up and re-trigger diamond selection === */
    localStorage.removeItem('_vow_item_cart');
    localStorage.removeItem('rc_selected_diamond');
    getCartItem(); // refresh mini cart
    
    $('#rc-generic-popup').removeClass('open');

    /* === Re-run saveSelectedDiamond with the originally clicked cert === */
    const cert = localStorage.getItem('_clicked_button_cert_id');
    localStorage.removeItem('_clicked_button_cert_id');

    if (cert) {
      /* === Reset the previously selected button back to unselected state === */
      const $prevBtn = $(`.rc-bespoke-select-diamond-btn[data-cert="${cert}"]`);
      $prevBtn.text('SELECT THIS DIAMOND').removeClass('selected').prop('disabled', false);
      $prevBtn.siblings('.rc-bespoke-remove-diamond-btn').addClass('hidden');

      /* === Find the diamond data from the table and re-trigger === */
      let diamondData = null;
      if (typeof table !== 'undefined') {
        table.rows().every(function () {
          const rowData = this.data();
          if (rowData?.raw?.cert_num == cert) {
            diamondData = rowData.raw;
          }
        });
      }
      if (diamondData) {
        await saveSelectedDiamond(diamondData);
      }
    }

  } catch (err) {
    console.error('RC: Update my ring error:', err);
    btn.textContent = 'UPDATE MY RING';
    btn.disabled = false;
  }
});